import type { FC } from 'react';

import type { CardType } from '@shared/cards-types';

import { getLocalizedCardType } from './getLocalizedCardType';

interface Props {
    cardType: CardType;
    cardHolderName?: string;
}

export const CardTypeView: FC<Props> = ({ cardType, cardHolderName }) => (
    <>
        {getLocalizedCardType(cardType)}
        {cardHolderName && <span data-cy="card-holder-name"> - {cardHolderName}</span>}
    </>
);
